import toastComponent from './toast.vue';
var plugin = {
  install: function install(vue, options) {
    var Toast = vue.extend(toastComponent);

    Toast.prototype.close = function () {
      var _this = this;

      this.$data.visiable = false;
      this.$el.addEventListener('transitionend', function () {
        document.body.removeChild(_this.$el);
      });
    };

    var toast = function toast() {
      var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var instance = new Toast().$mount();
      var duration;

      if (typeof option === 'string') {
        instance.message = option;
        duration = 2500;
      } else {
        instance.message = option.message;
        duration = option.duration;
      }

      document.body.appendChild(instance.$el);
      setTimeout(function () {
        instance.$data.visiable = true;
      }, 0);
      setTimeout(function () {
        instance.close();
      }, duration);
      return instance;
    };

    vue.$toast = toast;
    vue.prototype.$toast = toast;
  }
};
export default plugin;